import { useTheme } from 'next-themes';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

const TOASTER_STYLES = [
  'toaster',
  'group',
  // close button position and styles
  '[&_[data-sonner-toast][data-styled=true]_[data-close-button]]:!right-0',
  '[&_[data-sonner-toast][data-styled=true]_[data-close-button]]:!left-auto',
  '[&_[data-sonner-toast][data-styled=true]_[data-close-button]]:!top-2',
  // '[&_[data-sonner-toast][data-styled=true]_[data-close-button]]:!-translate-x-1/2',
  '[&_[data-sonner-toast][data-styled=true]_[data-close-button]]:!translate-y-1/2',
  '[&_[data-sonner-toast][data-styled=true]_[data-close-button]]:!border-none',
  '[&_[data-sonner-toast][data-styled=true]_[data-close-button]]:!opacity-0',
  '[&_[data-sonner-toast][data-styled=true]_[data-close-button]]:!transition-opacity',
  '[&_[data-sonner-toast][data-styled=true]_[data-close-button]]:!duration-200',
  '[&_[data-sonner-toast][data-styled=true]_[data-close-button]]:!ease-in-out',
  '[&_[data-sonner-toast][data-styled=true]_[data-close-button]:hover]:!bg-foreground/10',
  // only display close button on hover
  '[&_[data-sonner-toast][data-styled=true]:hover_[data-close-button]]:!opacity-100',
  // description color theme handling
  '[&_[data-sonner-toast][data-styled=true]_[data-description]]:!text-popover-foreground',
].join(' ');

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();
  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className={TOASTER_STYLES}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as React.CSSProperties
      }
      toastOptions={{
        style: {
          fontSize: 'var(--text-sm)',
          fontWeight: 'var(--font-normal)',
          minHeight: '70px',
          maxHeight: '200px',
          wordBreak: 'break-word',
          overflowY: 'auto',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
